let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bLJUJ")).then(() => parcelRequire('3mc0z'));